<template>
  <StatisticCardList
    v-bind="$attrs"
    layout="list"
    :data="data"
    :size="size"
    :reverse-color="reverseColor"
    :pagination="pagination"
  />
</template>

<script setup lang="ts">
// @ts-nocheck SFC 泛型 defineProps 编译产物中 type-only import 被内联后触发 TS6192(未使用导入);源码类型已由 typecheck:web 保证
import StatisticCardList from '../supporting/statistic-card-list.vue'
import type { StatisticCardItemData, StatisticCardSize, PaginationConfig } from '../types'

defineOptions({ name: 'JdStatisticCardList', inheritAttrs: false })

defineProps<{
  data: StatisticCardItemData[]
  size?: StatisticCardSize
  reverseColor?: boolean
  pagination?: PaginationConfig
}>()
</script>
